import InterviewList, { Columns, OrderValue } from 'components/Interview/List';
import React, { FC, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { setOrder, setPage } from 'store/actions/mentee/interviewLists';
import { StoreState } from 'store/reducers';
import useSWR from 'swr';
import Interview from 'types/Interview';
import { Action } from 'types/typeguards/reducerActions';

export const activeColumns: Columns = {
  date: true,
  hour: true,
  status: true,
  menteeName: false,
  type: true,
  viewDetails: true,
};

type RetrievedData = {
  interviews: Interview[] | undefined;
  count: number | undefined;
  pages: number | undefined;
};

type Props = {
  page: number;
  setPage: (page: number) => void;
  order: OrderValue;
  setOrder: (order: OrderValue) => void;
};

const Interviews: FC<Props> = ({ page, setPage, order, setOrder }) => {
  const { data } = useSWR<RetrievedData>(
    `/interview/mentee?page=${page}&order=${order}`,
  );

  // 1. On définit le nom une fois pour toutes : currentUserId
  const currentUserId = useSelector((state: StoreState) => {
    const s = state as any;
    return s.auth?.user?.id || s.mentee?.id || s.mentee?.mentee?.id;
  });

  const [retrievedData, setRetrievedData] = useState<RetrievedData>({
    interviews: undefined,
    count: undefined,
    pages: undefined,
  });

useEffect(() => {
  if (data?.interviews && data.interviews.length > 0) {
    // STRATÉGIE DE LA DERNIÈRE CHANCE :
    // On sait que sur cette page, l'utilisateur est soit l'auteur, soit le destinataire.
    // On récupère l'ID du mentoré qui est forcément présent dans l'objet mentorship.
    const first = data.interviews[0];
    
    // On essaie tous les chemins possibles pour trouver ce fameux 10054
    const myId = currentUserId || 
                 first?.mentorship?.menteeId || 
                 (first?.mentorship as any)?.mentee?.id;

    console.log("--- DEBUG RECOURS ---");
    console.log("Mon ID identifié :", myId);

    const enriched = data.interviews.map(interview => {
      const status = interview?.status || '';
      
      // On compare avec l'auteur (10054)
      const isAuthor = myId ? String(interview.authorId) === String(myId) : false;

      return {
        ...interview,
        isAuthor: isAuthor,
        // SI je suis l'auteur et que c'est en attente :
        // On change le statut en WAITING_REVIEW pour tromper le composant Chip
        // afin qu'il affiche "En attente" au lieu de "À votre réponse"
        status: (isAuthor && (status === 'WAITING_MENTOR' || status === 'WAITING_MENTEE'))
          ? 'WAITING_REVIEW' as any 
          : interview.status
      };
    }).sort((a, b) => (Number(b?.id) || 0) - (Number(a?.id) || 0));

    setRetrievedData({ 
      ...data, 
      interviews: enriched as any 
    });
  }
}, [data, currentUserId]);

  return (
    <>
        <InterviewList
        variant="mentee"
        interviews={retrievedData.interviews}
        {...({
          activeColumns,
          setPage,
          page,
          order,
          setOrder,
        } as any)}
        loading={!data}
        pages={retrievedData.pages}
        currentUserId={currentUserId} 
      />
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    page: state.mentee.interviewLists.main.page,
    order: state.mentee.interviewLists.main.order,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setPage: (page: number) => dispatch(setPage('main', page)),
    setOrder: (order: OrderValue) => dispatch(setOrder('main', order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Interviews);
